import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			fill: "#262626",
			children: [/* @__PURE__ */ _jsx("path", { d: "m24 21.119-2.646-2.647c.397-.365.646-.89.646-1.472l2 2v2.119Zm0-8-2-2v-2.12l2 2v2.12Zm0-7.281L18.162 0h2.12L24 3.719v2.119ZM10.881 0h2.12l5 5h-2.12l-5-5Zm-8 0h2.12l5 5H7.88l-5-5ZM0 6.119v-2.12l2.177 2.178C2.063 6.427 2 6.707 2 7v1.119l-2-2Zm0 8v-2.12l2 2v2.12l-2-2Zm0 7.76v-2.12L4.24 24H2.122L0 21.878ZM12 24H9.881l-5-5h2.12l5 5Zm8 0h-2.119l-5-5h2.12l5 5Z" }), /* @__PURE__ */ _jsx("path", {
				d: "M20 6.5H4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5ZM4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4Z",
				fillRule: "evenodd",
				clipRule: "evenodd"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h24v24H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22%23262626%22%3E%3Cpath%20d%3D%22m24%2021.119-2.646-2.647c.397-.365.646-.89.646-1.472l2%202v2.119Zm0-8-2-2v-2.12l2%202v2.12Zm0-7.281L18.162%200h2.12L24%203.719v2.119ZM10.881%200h2.12l5%205h-2.12l-5-5Zm-8%200h2.12l5%205H7.88l-5-5ZM0%206.119v-2.12l2.177%202.178C2.063%206.427%202%206.707%202%207v1.119l-2-2Zm0%208v-2.12l2%202v2.12l-2-2Zm0%207.76v-2.12L4.24%2024H2.122L0%2021.878ZM12%2024H9.881l-5-5h2.12l5%205Zm8%200h-2.119l-5-5h2.12l5%205Z%22%2F%3E%3Cpath%20d%3D%22M20%206.5H4a.5.5%200%200%200-.5.5v10a.5.5%200%200%200%20.5.5h16a.5.5%200%200%200%20.5-.5V7a.5.5%200%200%200-.5-.5ZM4%205a2%202%200%200%200-2%202v10a2%202%200%200%200%202%202h16a2%202%200%200%200%202-2V7a2%202%200%200%200-2-2H4Z%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
